import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_PROMOTION } from './router';

menuRegistry.registerMenu([
    {
        parent: 'Multiplayer',
        key: 'Promotion',
        name: 'Promotion',
        icon: 'fas fa-percentage'
    },
    {
        parent: 'Multiplayer.Promotion',
        key: 'Item',
        name: 'Item',
        icon: 'fas fa-clipboard-list',
        route: { name: ROUTE_NAME_PROMOTION.ITEM.INDEX }
    },
    {
        parent: 'Multiplayer.Promotion',
        key: 'Prototype',
        name: 'Prototype',
        icon: 'far fa-smile-beam',
        route: { name: ROUTE_NAME_PROMOTION.PROTOTYPE.INDEX }
    },
    {
        parent: 'Multiplayer.Promotion',
        key: 'Booster',
        name: 'Booster',
        icon: 'fas fa-syringe',
        route: { name: ROUTE_NAME_PROMOTION.BOOSTER.INDEX }
    },
    {
        parent: 'Multiplayer.Promotion',
        key: 'Plan',
        name: 'Plan',
        icon: 'fas fa-calendar',
        route: { name: ROUTE_NAME_PROMOTION.PLAN.INDEX }
    },
    {
        parent: 'Multiplayer.Promotion',
        key: 'Cycle',
        name: 'Cycle',
        icon: 'fas fa-sync-alt',
        route: { name: ROUTE_NAME_PROMOTION.CYCLE.INDEX }
    }
]);

export default registerRouteForModule(router);
